<template>
  <section v-if="locationList.length > 0" class="location mb-5 md:mb-12">
    <div v-if="appStore.isMobileScreen" class="mobile-location-list">
      <h2 class="text-lg font-500 my-4 truncate">{{ $t('home.location.title') }}</h2>
      <div class="flex flex-col items-start gap-4 pt-2 -mx-5 px-5 scrollbar no-scrollbar">
        <div v-for="(group, index) in locationList" :key="index" class="flex gap-2">
          <etg-button v-for="item in group" :key="item.id" v-bind="getLinkBtnProps(item.id!)">
            {{ item.name }}
          </etg-button>
        </div>
      </div>
    </div>
    <carousel v-else :title="$t('home.location.title')" navigator :data="locationList" :gap="16" swiper-container-class="mt-4">
      <template #default="{ item: group }">
        <div class="flex flex-col gap-4">
          <div v-for="item in group" :key="item.id" class="location relative overflow-hidden rounded">
            <etg-button v-bind="getLinkBtnProps(item.id!)">
              {{ item.name }}
            </etg-button>
          </div>
        </div>
      </template>
      <template #skeleton>
        <div class="skeleton-wrapper flex overflow-hidden gap-4">
          <div v-for="i in 4" :key="i" class="flex flex-col gap-4">
            <n-skeleton v-for="j in 2" :key="j" class="skeleton-card w-300px h-48px rounded" />
          </div>
        </div>
      </template>
    </carousel>
  </section>
</template>

<script lang="ts" setup>
import { NSkeleton } from 'naive-ui'
import { chunk } from 'lodash-es'

import Carousel from '@/components/common/carousel.vue'

import { useAppStore } from '@/store/app'
import { useRegionStore } from '@/store/region'

const MAX_DISPLAY_COUNT = 20
const ITEMS_PER_ROW_THRESHOLD = 8

const appStore = useAppStore()
const regionStore = useRegionStore()
const { regionInfo } = storeToRefs(regionStore)

const { regionId } = useRegion()

const locations = computed(() => regionInfo.value?.location?.slice(0, MAX_DISPLAY_COUNT))
const locationList = computed(() => {
  if (!locations.value) {
    return []
  }

  const chunkSize = locations.value.length > ITEMS_PER_ROW_THRESHOLD ? 2 : 1
  const chunkFn = appStore.isMobileScreen ? mobileChunk : chunk

  return chunkFn(locations.value, chunkSize)
})

function mobileChunk<T>(list: T[], chunkSize: number) {
  const initAry = Array.from({ length: chunkSize }, () => [])

  return list.reduce<T[][]>((acc, cur, index) => {
    const _index = index % chunkSize

    acc[_index].push(cur)

    return acc
  }, initAry)
}

function getLinkBtnProps(id: number) {
  return {
    to: `/regions/${regionId.value}/categories/${id}`,
    type: 'secondary' as const,
    icon: appStore.isDesktopScreen ? ('arrow-right' as const) : undefined,
    iconPosition: 'right' as const,
    class: 'px-4 py-2 md:p-3 md:pl-5 md:w-300px',
    truncateText: appStore.isDesktopScreen,
  }
}
</script>
